import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { ErrorHandlingService } from 'src/app/core/services/error-handling.service';
import { HttpService } from 'src/app/core/services/api/http.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-export-records',
  templateUrl: './export-records.component.html',
  styleUrls: ['./export-records.component.css'],
})
export class ExportRecordsComponent implements OnInit {
  @Input('module') module: any;
  @Input('showBtn') showBtn = true;
  @Input('columnsApi') columnsApi: any;
  @Input('exportApi') exportApi: any;
  @Input('textButton') textButton: string = 'Export';
  @Input() withFilters = true;
  showExportPopUp: boolean = false;
  loadingSubmit: boolean = false;

  // when canceling popup from outside of cancel button open discard popup
  @ViewChild('messageComponent', { static: false }) messageComponent: any;
  loadingConfirm: boolean = false;
  isLoading: boolean = false;
  exportForm!: FormGroup;
  columns: any[] = [];

  formats: any = [
    { name: 'Spreadsheet(.csv)', key: 'csv' },
    // {name:'Spreadsheet(.xlsx)',key:'xlsx'},
    // {name:'Page layout(.pdf)',key:'pdf'},
  ];
  selectedFormat: any;
  showExportFeature: boolean = environment.showExportFeature;

  constructor(
    private _api: HttpService,
    private activatedRoute: ActivatedRoute,
    private notificationService: NotificationsService,
    private errHandle: ErrorHandlingService,
    private $http: HttpClient
  ) {}

  ngOnInit(): void {
    this.exportForm = new FormGroup({
      columns: new FormControl('', []),
      format: new FormControl({ name: 'Spreadsheet(.csv)', key: 'csv' }, []),
      isSelectAllColumns: new FormControl(true, []),
    });
  }

  openPopup() {
    this.showExportPopUp = true;
    this.exportForm.controls['isSelectAllColumns'].setValue(true);

    this.isLoading = true;
    this._api.getReq(`/export/${this.columnsApi}/columns`).subscribe(
      (res) => {
        this.columns = [];
        const keys = Object.keys(res?.data);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          const value = res?.data[key];
          this.columns.push({ name: value, id: key });
        }
        this.isLoading = false;
        this.exportForm.controls['columns'].setValue(this.columns);
      },
      (err) => {
        this.errHandle.errorHandling(err);
        this.isLoading = false;
      }
    );
  }

  onHide() {}

  // open confirmation popup in case the user click on cancel or outside the popup
  accepted() {
    this.messageComponent.close();
    this.showExportPopUp = false;
    this.exportForm.reset();
  }

  rejected() {
    this.messageComponent.close();
  }

  closeModalOutside(event: any) {
    // if the form not dirty it's not important to show the discard message
    if (this.exportForm.dirty) {
      this.messageComponent.open();
    } else {
      this.accepted();
    }
  }

  save() {
    if (this.isLoading) {
      return;
    }

    this.loadingSubmit = true;

    let payload: any = {
      format: this.exportForm.controls['format'].value?.key,
    };

    this.selectedFormat = this.exportForm.controls['format'].value?.key;

    let selectedColumns: any[] = [];

    if (!this.exportForm.controls['isSelectAllColumns'].value) {
      this.exportForm.controls['columns'].value.forEach((col: any) => {
        selectedColumns.push(col?.id);
      });

      payload['columns'] = selectedColumns;
    }

    let exportUrl = `/export/data/${this.exportApi}`;
    if (this.withFilters) {
      const { sort, ...otherQueryParams } =
        this.activatedRoute.snapshot.queryParams;
      payload = { ...payload, ...otherQueryParams };
      if (sort) {
        exportUrl = `/export/data/${this.exportApi}?sort=${sort}`;
      }
    }

    this._api.postReq(exportUrl, payload).subscribe(
      (res: any) => {
        this.loadingSubmit = false;
        this.showExportPopUp = false;
        this.notificationService.success('', res?.message);
        if (res.url) {
          window.open(res.url, '_blanc');
        }
      },
      (err) => {
        this.loadingSubmit = false;
        // this.exportForm.markAsPending();
        // this.showExportPopUp = false;
        // this.downloadFile(err?.error?.text);
        this.errHandle.errorHandling(err);
      }
    );
  }

  onChangeCheckBox(e: any) {
    if (e?.checked) {
      this.exportForm.controls['columns'].setValue(this.columns);
    } else {
      this.exportForm.controls['columns'].setValue('');
    }
  }

  onChangeDrop(e: any) {
    if (
      this.exportForm.controls['columns'].value.length == this.columns.length
    ) {
      this.exportForm.controls['isSelectAllColumns'].setValue(true);
    } else if (this.exportForm.controls['columns'].value.length >= 0) {
      this.exportForm.controls['isSelectAllColumns'].setValue(false);
    }
  }

  downloadFile(binaryData: any) {
    const blob = new Blob([binaryData], { type: 'application/octet-stream' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download =
      this.module +
      '-' +
      new Date().getMilliseconds() +
      '.' +
      this.selectedFormat; // Set the filename
    a.click();
  }
}
